<template>
  <div class="client-step-five_block">
    <div class="left">
      <h3 class="large_blue_label">5. 納品・検収</h3>
      <p>オペレーターの作業が完了し、納品されるとフルーからメール通知が届きます。</p>
      <br>
      <p class="marker-underline_label">クライアントは成果品の確認を行い、合格であれば「検収」ボタンを押してください。</p>
      <br>
      <br>
      <p>不合格の時の対処法（作業時間払いで業務終了とするか、是正処置をするか等）については、あらかじめクライアントとオペレーターの間で契約時に決めておき、その方針に従うこととします。</p>
    </div>
    <div class="right">
      <img class='base_image' src='@/assets/image/pages/information/usages/cl_five_steps_5.png'>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ClientStepFiveBlock"
  }
</script>

<style lang="scss" scoped>
  .client-step-five_block {
    @include double_columns(40%, 35%);

    .large_blue_label {
      margin-bottom: 2rem;
    }

    @media screen and (max-width: 767px) {
      > .right > .base_image {
        margin: 2rem auto 0 auto;
      }
    }
  }
</style>